import React from "react";

const Footer = () => {
  return (
    <div className="text-center text-light">
      <br />
      Made with &#10084; from &nbsp;
      <a
        href="https://github.com/kaamil-ahamadh"
        target="_blank"
        rel="noreferrer noopener"
        className="footer-name text-accent"
      >
        Kaamil
      </a>
      <br />
      <br />
    </div>
  );
};

export default Footer;
